import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconChrome = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--chrome")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M12 1a11.002 11.002 0 0 1 10.068 6.56l.04.096C22.683 8.988 23 10.457 23 12c0 6.075-4.925 11-11 11a11.125 11.125 0 0 1-1.31-.078C5.233 22.275 1 17.632 1 12c0-2.42.781-4.656 2.105-6.472a.874.874 0 0 1 .098-.133A10.984 10.984 0 0 1 12 1zm8.488 8H16c.628.835 1 1.874 1 3 0 .972-.277 1.88-.757 2.647l-3.654 6.334a9 9 0 0 0 7.899-11.98zM3 12c0 4.408 3.17 8.077 7.354 8.85l2.242-3.885a5 5 0 0 1-5.02-2.632L3.927 8.017A8.963 8.963 0 0 0 3 12zm9-3a3 3 0 0 0-2.662 4.384l.068.116.02.035a2.998 2.998 0 0 0 5.098.087l.07-.122.03-.05A3 3 0 0 0 12 9zm0-6a8.98 8.98 0 0 0-6.841 3.152l2.243 3.881A5.001 5.001 0 0 1 12 7h7.484A8.991 8.991 0 0 0 12 3z" id="icon--centivo--chrome"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--chrome"/>
      </g>
  </IconWrapper>
)
